import {TranslatableModel} from "../translatable-model";

export class AbstractReport extends TranslatableModel {

}



// WEBPACK FOOTER //
// ./src/pms-api/models/reports/abstract-report.model.js